<template>
  <el-dialog
    :title="$t('Fee.CheckBeneficiaryAccount')"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :lock-scroll="true"
    center
    :show-close="false"
  >
    <div class="content">
      <div class="account-info">
        <div>
          <div class="info-title">
            {{ $t('Fee.BankNumber') }}
          </div>
          <div class="info-data">
            {{ accountConfig?.BankBranchCode }}
          </div>
        </div>
        <div>
          <div class="info-title">
            {{ $t('Fee.Account') }}
          </div>
          <div class="info-data">
            {{ accountConfig?.Account }}
          </div>
        </div>
        <div>
          <div class="info-title">
            {{ $t('Fee.AccountName') }}
          </div>
          <div class="info-data">
            {{ accountConfig?.AccountName }}
          </div>
        </div>
        <div class="btn-wrap">
          <el-button
            size="mini"
            type="primary"
            @click="updateAccount"
          >
            {{ $t('Fee.UpdateAccount') }}
          </el-button>
        </div>
      </div>
      <div class="hint">
        <div>
          <i class="icon-filled-info" />
        </div>
        <div class="context">
          {{ $t('Fee.CheckBeneficiaryAccountHint[0]') }}
          <br />
          <br />
          {{ $t('Fee.CheckBeneficiaryAccountHint[1]') }}
        </div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        round
        @click="close"
      >
        {{ $t('General.Cancel') }}
      </el-button>
      <el-button
        v-if="isShowNextButton"
        type="primary"
        round
        @click="nextStep"
      >
        {{ $t('Fee.BeneficiaryAccountConfirmToNext') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    dialogVisible: Boolean,
    isShowNextButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      accountConfig: state => state.fee.accountConfig
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
    nextStep () {
      this.$emit('nextStep')
      // 若開啟下個彈窗及關閉此彈窗同時進行，會發生 backdrop 閃一下的狀況
      this.$nextTick(() => { this.close() })
    },
    updateAccount () {
      this.$emit('updateAccount')
      // 若開啟下個彈窗及關閉此彈窗同時進行，會發生 backdrop 閃一下的狀況
      this.$nextTick(() => { this.close() })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-right: 30px;
  gap: 50px;
  & > div {
    width: 50%;
  }
  .account-info {
    .info-title {
      font-size: map-get($fontSize, large);
      font-weight: bold;
      color: $mainFontColor;
      margin-bottom: 15px;
    }
    .info-data {
      font-size: map-get($fontSize, medium);
      color: $hintColor;
      margin-bottom: 20px;
    }
    .btn-wrap {
      margin-top: 40px;
    }
  }
  .hint {
    display: flex;
    gap: 10px;
    background-color: rgba(0, 182, 164, 0.1);
    border-radius: 10px;
    padding: 15px 15px 34px;
    font-size: map-get($fontSize, medium);
    .icon-filled-info {
      font-size: map-get($fontSize, xx-large);
      color: $mainColor;
    }
    .context {
      line-height: 24px;
    }
  }
}
</style>
